// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1NaLR","row":"ProcedureTreatmentSummary_row__Vym6y"};